import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { Switch as SwitchAnt } from 'antd';
var Switch = function Switch(props) {
  var onChange = props.onChange,
    defaultChecked = props.defaultChecked;
  return /*#__PURE__*/React.createElement(SwitchAnt, _extends({
    defaultChecked: defaultChecked,
    onChange: onChange
  }, props));
};
Switch.propTypes = {
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool
};
Switch.defaultProps = {
  defaultChecked: false,
  onChange: _noop
};
export default Switch;